module.exports = "<my-title my-label=\"$root.labels.train.statements.edit\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"3\">\n</my-title>\n\n<my-train-edit-form my-train=\"$$train.data.myTrain\">\n</my-train-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/train/templates/edit.html
// module id = 1526
// module chunks = 0